import React from "react";

const ReportsIcon = (props: any) => {
  return (
    <svg
      width="419"
      height="438"
      viewBox="0 0 419 438"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M27.4667 4.00001C17.7334 8.00001 9.06669 16.2667 4.26669 26L0.666687 33.3333V218.667V404L4.13335 411.333C9.06669 422 14.9334 428 25.0667 432.933L34 437.333L131.467 437.733C219.6 438 229.2 437.867 231.2 436C233.733 433.333 234 429.467 231.6 427.6C230.4 426.533 200.4 426 132.533 425.733C40.6667 425.333 35.0667 425.2 30.6667 422.8C24.1334 419.333 18.9334 414.267 15.6 408L12.6667 402.667V218.533V34.4L16.6667 27.8667C19.2 23.8667 23.2 19.8667 27.2 17.3333L33.7334 13.3333L134.267 12.9333L234.667 12.6667V60.5334C234.667 102.4 234.933 108.8 236.8 110.533C238.533 112.4 244.933 112.667 286.8 112.667H334.667V176.4C334.667 224.133 335.067 240.533 336.267 241.733C338.667 244.133 343.733 243.6 345.333 240.8C346.133 239.067 346.667 214.8 346.667 171.067V104.133L295.067 52.4L243.333 0.66668H139.333H35.3334L27.4667 4.00001ZM286.667 61.3334L326 100.667H286.267H246.667V61.3334C246.667 39.7333 246.8 22 247.067 22C247.2 22 265.067 39.7333 286.667 61.3334Z"
        fill="black"
      />
      <path
        d="M67.3334 151.867C65.6001 154.4 65.4667 155.733 66.6667 157.867C68.1334 160.667 68.2667 160.667 176 160.667C283.733 160.667 283.867 160.667 285.333 157.867C286.533 155.733 286.4 154.4 284.667 151.867L282.667 148.667H176H69.3334L67.3334 151.867Z"
        fill="black"
      />
      <path
        d="M86.9334 218.933C84 220.133 82.4 224.4 84 227.333C85.4667 230 86.8 230 176.133 230H266.667L268.267 226.667C269.467 223.867 269.333 222.933 267.333 220.667C264.933 218 263.333 218 176.8 218.133C128.267 218.133 87.8667 218.533 86.9334 218.933Z"
        fill="black"
      />
      <path
        d="M272.667 264.8C260.667 267.733 250.4 277.467 246 289.867C237.467 314.133 256.4 340 282.667 339.733C304 339.6 320 323.333 320 302C320 286.533 310.8 272.533 296.933 266.667C290.667 264 279.2 263.2 272.667 264.8ZM289.467 276.8C300.933 280.667 308 290.267 308 302C308 316.933 297.467 327.333 282.4 327.333C272.667 327.2 265.067 323.6 260.4 316.533C257.2 311.733 256.667 309.467 256.667 302C256.667 290.267 260.933 283.333 271.067 278.533C278.8 274.933 282.8 274.667 289.467 276.8Z"
        fill="black"
      />
      <path
        d="M326.933 346.267C264.267 408.933 258.667 414.933 258.933 418.667C259.333 422 260 422.8 263.2 423.067C266.8 423.467 273.067 417.6 335.6 355.067C381.467 309.2 404 285.733 404 284C404 280.4 401.6 278 398.133 278C396.267 278 372.267 301.067 326.933 346.267Z"
        fill="black"
      />
      <path
        d="M57.0667 288.8C54.2667 290.4 53.8667 295.333 56.2667 297.733C57.4667 298.933 77.8667 299.333 140 299.333C185.067 299.333 222.667 298.8 223.467 298.267C226.4 296.267 226.667 292.667 224 290C221.467 287.467 219.333 287.333 140.4 287.333C87.8667 287.467 58.5333 287.867 57.0667 288.8Z"
        fill="black"
      />
      <path
        d="M102.133 358.8C99.6 361.2 99.4667 362.533 101.333 366.133C102.667 368.533 104.933 368.667 169.067 368.667C218.933 368.667 235.867 368.267 237.067 367.067C239.467 364.667 238.933 359.6 236.133 358C234.4 357.2 210.933 356.667 168.8 356.667C111.867 356.667 104 356.933 102.133 358.8Z"
        fill="black"
      />
      <path
        d="M369.333 363.2C353.2 368.133 342.667 382.667 342.667 400C342.667 421.867 359.067 438 381.333 438C402.8 438 420.667 417.467 418.133 395.733C416.533 382.267 409.467 372.267 397.067 366.133C390.533 362.8 387.333 362 380.8 362.133C376.267 362.133 371.2 362.667 369.333 363.2ZM391.6 376.533C402.533 381.6 408.667 395.067 405.467 407.067C399.6 428.667 370 432.8 358.133 413.6C344.533 391.6 367.867 365.867 391.6 376.533Z"
        fill="black"
      />
    </svg>
  );
};

export default ReportsIcon;
